import {BaseContainerModel} from '../../base-container.model';
import {Bl_inv_stock_take_session_event_RowClass} from '../../../dbschema/bl_inv_stock_take_session_event.model';

export class StockTakeSessionEventModel extends BaseContainerModel {
  event: Bl_inv_stock_take_session_event_RowClass = new Bl_inv_stock_take_session_event_RowClass();
}
